import { render, staticRenderFns } from "./UpdateCarrierSimCardsInfo.vue?vue&type=template&id=15302af9&"
import script from "./UpdateCarrierSimCardsInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateCarrierSimCardsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports